export default {
  owner: `Assigned to`,
  attributeOwner: 'Assigned to',
  deadline: 'Deadline',
  note: 'Note',
  alertmessage: 'Your message',
  progression: `Progression`
}
